<template>

  <div class="wrapper" id="app">
    <!-- CARD WITH VERTICAL ICON TABS -->

    <div class="vx-col w-full ">
      <vs-popup title="Plan Demo Activo" :active.sync="demoPlanPopup" class="demo-plan-popup">
        <div class="p-6 text-center">
          <img :src="require('@/assets/images/pages/demo-upgrade.png')" alt="Activar Plan Flexible" class="mx-auto mb-4" style="max-height: 180px; object-fit: contain;">
          <h3 class="mb-3 font-bold text-2xl" style="color: #2c2c2c;">Activa tu Plan Flexible</h3>
          <p class="mb-6 text-base leading-relaxed" style="color: #5f5f5f; font-size: 15px;">
            Estás utilizando el Plan Demo. Para adquirir firmas adicionales, <b>activa el Plan Flexible o elige otro plan.</b>
          </p>
          <div class="flex justify-center items-center mt-4">
            <vs-button color="success" type="filled" class="font-bold mr-3" @click="switchToFlexiblePlan">
              Activar Plan Flexible
            </vs-button>
            <vs-button color="primary" type="border" class="font-bold" @click="goToPlans">
              Ver Planes
            </vs-button>
          </div>
        </div>
      </vs-popup>
      <div class="vx-row">
        <div class="mb-6 vx-col w-full md:w-full lg:w-3/5">
          <vx-card class="card-sig">
            <div class="vx-row">
              <div class="vx-col w-full">
                <h4>{{ credits }} Firmas</h4>

                <ul class="demo-alignment">
                  <li>
                    <vs-input-number min="1" v-model="credits" label="No. Firmas:"/>
                  </li>
                  <li>
                    <vs-button class="p-btn-sg" color="primary" type="border" @click="credits = 20">20 Firmas</vs-button>
                  </li>
                  <li>
                    <vs-button class="p-btn-sg" color="primary" type="border" @click="credits = 30">30 Firmas</vs-button>
                  </li>
                  <li>
                    <vs-button class="p-btn-sg" color="primary" type="border" @click="credits = 50">50 Firmas</vs-button>
                  </li>

                </ul>
              </div>
            </div>
          </vx-card>
        </div>

        <div class="mb-6 vx-col w-full sm:w-full md:w-full lg:w-2/5">
          <vx-card>
            <h3 class="text-center text-primary">Resumen</h3>
            <div class="vx-row mt-1">
              <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 text-right pr-1">
                <span class="font-w-600">Precio Unitario:</span>
              </div>
              <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 text-left">
                <span class="d-contens">({{ signaturePrice.toLocaleString('es-MX', {style:'currency', currency:'MXN'}) }} c/u)</span>
              </div>
              <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 text-right pr-1">
                <span class="font-w-600">Descuento:</span>

              </div>
              <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 text-left">
                <span v-if="isPlanProfesional" class="d-contens">-{{ discountForProUsers }}%</span>

                <span v-else class="d-contens">Solo Plan Profesional <router-link to="/buy/plans">Cambiar</router-link></span>
              </div>
              <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 text-right pr-1">
                <h4 class="d-contens font-w-600 ">Total: </h4>
              </div>
              <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 text-left">
                <h4 class="d-contens">{{ totalCalculated }}</h4>
              </div>
            </div>
          </vx-card>

        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full lg:w-3/5 mb-10">

          <vx-card>
            <div>
              <div class="vx-row">
                <div class="vx-col lg:w-1/2 mt-4">
                  <h4 v-if="isCardMethod">Pago con tarjeta</h4>
                  <h4 v-if="isSpeiMethod">Transferencia interbancaria</h4>
                </div>
                <div class="vx-col lg:w-1/2 ">
                  <span :class="{'border-pay-active padding-card overflow-visible border-primary  vs-button d-inline-block mr-4': isCardMethod,
                   'border-pay padding-card2 border-primary  vs-button d-inline-block mr-4': !isCardMethod}"
                        @click="btnCard">
                    <img :src="require('@/assets/images/company-logos/card.svg')" width="62" alt="">
                    <feather-icon v-if="isCardMethod" icon="CheckIcon" class="check-pay"
                                  svgClasses="w-5 h-5 p-ab back-border text-white p-unset"/>
                  </span>

                  <span v-if="credits >= 20"
                    :class="{'border-pay-active padding-spei overflow-visible border-primary vs-button d-inline-block  mr-4': isSpeiMethod,
                   'border-pay padding-spei border-primary vs-button d-inline-block mr-4': !isSpeiMethod}"
                    @click="btnSpei">
                   <img :src="require('@/assets/images/company-logos/spei.svg')" width="45" alt="">
                   <feather-icon v-if="isSpeiMethod" icon="CheckIcon" class="check-pay2"
                                 svgClasses="w-5 h-5 p-ab back-border text-white p-unset"/>
                 </span>


                </div>
              </div>
              <div v-if="isCardMethod" :toggle-tab="toggleTab">
                <div v-if="selectCardAction" class="flex flex-col card-list-select">

                  <div class="card-select">
                    <img class="ml-4" :src="getLogoBrandOfCard(getSelectedCard.brand)" width="45" alt="">
                    <span class="ml-4">{{ getSelectedCard.name }}  **** {{ getSelectedCard.last }}</span>
                  </div>

                </div>

                <div v-else>
                  <div class="vx-row">
                    <div class="vx-col w-full w-1400-100 xl:w-1/2 mt-4">
                      <label for="cardNumber" class="card-input__label">Número de la tarjeta</label>
                      <input type="text" id="cardNumber" class="card-input__input" placeholder="1234-1234-1234-1234"
                             v-mask="generateCardNumberMask" v-model="cardNumber" v-on:focus="focusInput"
                             v-on:blur="blurInput" data-ref="cardNumber" autocomplete="off">
                    </div>

                    <div class="vx-col w-full w-1400-100 xl:w-1/2 mt-4">
                      <label for="cardName" class="card-input__label">Titular de tarjeta </label>
                      <input type="text" id="cardName" class="card-input__input" v-model="cardName"
                             v-on:focus="focusInput" v-on:blur="blurInput" data-ref="cardName" autocomplete="off">
                    </div>
                  </div>
                  <div class="card-input">
                  </div>
                  <div class="card-input">
                  </div>
                  <div class="card-form__row">
                    <div class="card-form__col">
                      <div class="card-form__group">
                        <label for="cardMonth" class="card-input__label">Fecha de expiración</label><br>
                        <select class="card-input__input -select" id="cardMonth" v-model="cardMonth"
                                v-on:focus="focusInput" v-on:blur="blurInput" data-ref="cardDate">
                          <option value="" disabled selected>Mes</option>
                          <option v-bind:value="n < 10 ? '0' + n : n" v-for="n in 12" v-bind:disabled="n < minCardMonth"
                                  v-bind:key="n">
                            {{ n < 10 ? '0' + n : n }}
                          </option>
                        </select>
                        <select class="card-input__input -select" id="cardYear" v-model="cardYear" v-on:focus="focusInput"
                                v-on:blur="blurInput" data-ref="cardDate">
                          <option value="" disabled selected>Año</option>
                          <br>
                          <option v-bind:value="$index + minCardYear" v-for="(n, $index) in 12" v-bind:key="n">
                            {{ $index + minCardYear }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="card-form__col -cvv">
                      <div class="card-input">
                        <label for="cardCvv" class="card-input__label">CVV</label>
                        <input type="text" class="card-input__input" id="cardCvv" v-mask="'####'" maxlength="4"
                               v-model="cardCvv" v-on:focus="flipCard(true)" v-on:blur="flipCard(false)"
                               autocomplete="off">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="vx-row mt-4">
                  <div class="vx-col w-full lg:w-1/2 mb-3">
                    <vs-button v-if="!blockSelectCard" type="border" color="primary" class="float-left" @click="selectCardAction = !selectCardAction">{{ selectCardAction ? 'Nueva tarjeta' : 'Regresar' }}</vs-button>
                    <vs-button v-if="selectCardAction" @click="popupCard=true" type="flat" color="primary" class="ml-3 float-left" >Ver todas mis tarjetas</vs-button>
                  </div>
                  <div class="vx-col w-full lg:w-1/2 ">
                    <vs-button color="primary" class="float-right" @click="selectCardAction ? submit() : submitPaymentMethod()">Pagar ahora</vs-button>
                  </div>
                </div>
              </div>


              <div v-if="isSpeiMethod" :toggle-tab="toggleTab">
                <div class="vx-row mt-4">
                  <div class="vx-col w-full">
                    <ol>
                      <li>Accede a tu banca en línea.</li>
                      <li>Da de alta la CLABE que aparece en la ficha. <strong>El banco deberá de ser STP</strong>.</li>
                      <li>Realiza la transferencia correspondiente por la cantidad exacta mostrada en la ficha, <strong>de
                        lo contrario se rechazará el cargo</strong>.
                      </li>
                      <li>Al confirmar tu pago, el portal de tu banco generará un comprobante digital. <strong>En el
                        podrás verificar que se haya realizado correctamente.</strong> Conserva este comprobante de
                        pago.
                      </li>
                    </ol>
                  </div>
                </div>

                <div class="vx-row">
                  <div class="vx-col w-full">
                    <vs-button color="primary" class="float-right" @click="buyCreditsSpei">Generar refencia
                    </vs-button>
                  </div>
                </div>

              </div>


            </div>
          </vx-card>
        </div>

        <div class="card-form2 vx-col lg:w-2/5">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">

                <feather-icon icon="AwardIcon"
                              class="p-4 mb-6 bg-primary inline-flex rounded-full text-white shadow mr-5"
                              svgClasses="h-5 w-5"></feather-icon>
                <h2 class="mb-6 text-white d-inline-block ">Beneficios</h2>

                <div class="mt-3">
                  <ul class="list pl-5 pr-3 mt-text text-white">
                    <li class="list__item ">
                <span class="w-5 h-5 mr-2 feather-icon select-none relative">
                  <feather-icon icon="CheckIcon" class="top-3 text-white" svgClasses="w-5 h-5 text-white"></feather-icon>
                </span>
                      <span class="text-left">
                      Las firmas adquiridas como transacciones adicionales no tienen vigencia.

                </span>
                    </li>
                    <li class="list__item">
                <span class="w-5 h-5 mr-2 feather-icon select-none relative">
                  <feather-icon icon="CheckIcon" class="top-4 text-white" svgClasses="w-5 h-5 text-white"></feather-icon>
                </span>
                      <span class="text-left">
                  Disfruta de un 20% de descuento en el precio unitario de firmas contratando el Plan Profesional.

                     </span>
                    </li>

                  </ul>
                  <vs-button v-if="!isPlanProfesional" color="rgb(255, 255, 255)" class="text-primary font-w-600 mt-5" type="filled" to="/buy/plans">Cambiar a Plan Profesional</vs-button>

                </div>
              </vx-card>
            </div>

            <div class="vx-col w-full lg:w-1/2">

            </div>
          </div>
        </div>


        <div class="vx-col w-full mt-5">
          <div class="vx-row  card-form__inner bg-text-grey">
            <div class="vx-col w-full lg:w-1/3">
              <div class="p-2">
                <h3>¿Por qué solicitamos tu tarjeta?</h3>
                <p class="mt-3">
                  Solicitamos los datos de tu tarjeta para prevenir que tu suscripción sea interrumpida después de la
                  prueba grauita. Tu suscripción puede ser cancelada cuando tu quieras antes de tu fecha de cobro.
                </p>
              </div>
            </div>

            <div class="vx-col w-full lg:w-1/3">
              <div class="p-2">
                <h3>¿Qué tan fácil es cancelar?</h3>
                <p class="mt-3">
                  Puedes cancelar cuando tu quieras, envíanos un email cuando desees a <a
                  href="mailto:cancelacion@verificamex.com">cancelacion@verificamex.com</a>.
                </p>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/3">
              <div class="p-2">
                <h3>¿Qué pasará después?</h3>
                <p class="mt-3">
                  Serás redirigido al incio y ya tendrás habilidatas todas las funciones de Usuarios Avanzados.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <vs-popup title="Selecciona una tarjeta" :active.sync="popupCard">
      <h4>Selecciona una tarjeta</h4>

      <div class="flex flex-col card-list-select">
        <vs-radio v-for="(paymentMethod, index) in getPaymentMethods" :key="index" v-model="cardSelection" :vs-value="index" class="card-select">
          <img class="ml-4" :src="getLogoBrandOfCard(paymentMethod.brand)" width="45" alt="">
          <span class="ml-4">{{ paymentMethod.name }} **** {{ paymentMethod.last }}</span>
        </vs-radio>

        <div class="vx-row mt-4">
          <div class="vx-col w-full lg:w-1/2 mb-3">
            <vs-button type="border" color="primary" class="float-left" @click="popupCard = false;selectCardAction = false;">Nueva tarjeta</vs-button>
          </div>
          <div class="vx-col w-full lg:w-1/2 ">
            <vs-button color="primary" class="float-right" @click="submit()">Pagar ahora</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

  </div>
</template>


<script>

import router from "../../../../router";
import {CONEKTA_API_KEY} from "../../../../config/app";
import {round} from "echarts/lib/util/number";

export default {
  data() {
    return {
      demoPlanPopup: false,
      popupCard: false,
      selectCardAction: true,
      blockSelectCard: false,
      cardSelection: 0,
      credits: 10,
      signaturePrice: null,
      discountForProUsers: null,
      tabIndex: 1,
      radios1: '1',
      currentCardBackground: Math.floor(Math.random() * 25 + 1), // just for fun :D
      cardName: "",
      cardNumber: "",
      cardMonth: "",
      cardYear: "",
      cardCvv: "",
      minCardYear: new Date().getFullYear(),
      amexCardMask: "#### ###### #####",
      otherCardMask: "#### #### #### ####",
      cardNumberTemp: "",
      isCardFlipped: false,
      focusElementStyle: null,
      isInputFocused: false,
      interval: ""
    }
  },
  created() {
    this.$store.dispatch("creditPacks/getAll", {page: 1}).then(
      creditPacks => {
        this.signaturePrice = creditPacks.data[0].attributes.signaturePrice
        this.discountForProUsers = creditPacks.data[0].attributes.discountForProUsers
      }
    )
    this.$store.dispatch("paymentMethods/getAllCards").then(
      () => {
        let self = this;
        this.getPaymentMethods.each((paymentMethod, index) => {
          if (paymentMethod.default) {
            self.cardSelection = index
          }
        })
      }
    )
  },
  mounted() {
    this.cardNumberTemp = this.otherCardMask;
    const script = document.createElement('script')
    script.src = 'https://cdn.conekta.io/js/latest/conekta.js'
    script.async = true
    document.body.appendChild(script)

    if (this.isPlanDemo) {
      this.demoPlanPopup = true;
    }
  },
  beforeDestroy() {
    this.demoPlanPopup = false;
  },
  computed: {
    getSelectedCard() {
      let card = this.$store.state.paymentMethods.payments.data ? this.$store.state.paymentMethods.payments.data[this.cardSelection] : {};
      card.index = this.cardSelection
      return card
    },
    isCardMethod() {
      return this.tabIndex === 1;
    },
    isSpeiMethod() {
      return this.tabIndex === 2;
    },
    isPlanProfesional() {
      return this.$store.state.account.user.me.plan.name === 'Plan Profesional';
    },
    isPlanDemo() {
      const userPlan = this.$store.state.account.user ? this.$store.state.account.user.me.plan : null;
      return userPlan && (userPlan.id === 1 || userPlan.name === 'Plan Demo');
    },
    getCardType() {
      let number = this.cardNumber;
      let re = new RegExp("^4");
      if (number.match(re) != null) return "visa";

      re = new RegExp("^(34|37)");
      if (number.match(re) != null) return "amex";

      re = new RegExp("^5[1-5]");
      if (number.match(re) != null) return "mastercard";

      re = new RegExp("^6011");
      if (number.match(re) != null) return "discover";

      re = new RegExp('^9792')
      if (number.match(re) != null) return 'troy'

      return "visa"; // default type
    },
    generateCardNumberMask() {
      return this.getCardType === "amex" ? this.amexCardMask : this.otherCardMask;
    },
    minCardMonth() {
      if (this.cardYear === this.minCardYear) return new Date().getMonth() + 1;
      return 1;
    },
    totalCalculated() {
      console.log(this.roundUp(10.55))
      if (!this.isPlanProfesional) {
        return (this.credits * this.signaturePrice).toLocaleString('es-MX', {style:'currency', currency:'MXN'})
      } else {
        return this.roundUp((this.credits * this.signaturePrice) * ((100 - this.discountForProUsers) / 100)).toLocaleString('es-MX', {style:'currency', currency:'MXN'})
      }
    },
    getPaymentMethods() {
      return this.$store.state.paymentMethods.payments.data ? this.$store.state.paymentMethods.payments.data : [];
    },
  },
  watch: {
    cardYear() {
      if (this.cardMonth < this.minCardMonth) {
        this.cardMonth = "";
      }
    },
    credits() {
      if (this.credits < 20 && this.isSpeiMethod) {
        this.tabIndex = 1;
      }
    },
    getPaymentMethods() {
      if (!this.getPaymentMethods.length) {
        this.selectCardAction = false;
        this.blockSelectCard = true;
      }
    }
  },
  methods: {
    roundUp(decimal) {
      return Math.ceil(decimal * 100) / 100;
    },
    getLogoBrandOfCard(brand) {
      switch (brand) {
        case 'mastercard':
          return require('@/assets/images/card/type/master_2.svg');
        case 'visa':
          return require('@/assets/images/card/type/visa.svg');
        case 'amex':
          return require('@/assets/images/card/type/american.svg');
      }
    },
    changePlanSelected(id) {
      this.planSelectedRadio = id;
      this.tabIndex = 1;
    },
    toggleTab(index) {
      this.tabIndex = index;
    },
    btnCard() {
      this.tabIndex = this.tabIndex = 1;
    },
    btnSpei() {
      this.tabIndex = this.tabIndex = 2;
    },

    submitPaymentMethod() {
      this.$store.dispatch("alert/clear", {}, {root: true})
      window.Conekta.setPublicKey(CONEKTA_API_KEY);
      const tokenParams = {
        card: {
          number: this.cardNumber,
          name: this.cardName,
          exp_year: this.cardYear,
          exp_month: this.cardMonth,
          cvc: this.cardCvv
        }
      };
      window.Conekta.Token.create(tokenParams, token => {
        let self = this;
        this.$store.dispatch("paymentMethods/addCard", {tokenId: token.id}).then(
          card => {
            self.submit(card.payment_id)
          }
        )
      }, error => {
        this.$store.dispatch("alert/error", error.message_to_purchaser);
      });
    },
    showDemoPlanWarning() {
      this.demoPlanPopup = true;
    },
    goToPlans() {
      this.demoPlanPopup = false;
      this.$router.push('/buy/plans');
    },
    switchToFlexiblePlan() {
      this.demoPlanPopup = false;
      let instance = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Cambiar a Plan Flexible',
        text: '¿Estás seguro de cambiar al Plan Flexible? Se perderan las firmas del Plan Demo',
        acceptText: 'Sí, cambiar',
        cancelText: 'Cancelar',
        accept: function () {
          instance.$vs.loading({type: "point"});
          instance.$store.dispatch("plans/switchPlan", { planId: 3, paymentMethod: "CARD_METHOD", aclChangeRole: instance.$acl.change })
            .then(
              () => {
                instance.$vs.loading.close();
                instance.$store.dispatch("alert/success", "Se ha cambiado al Plan Flexible con éxito", { root: true });
                instance.$store.dispatch("account/me", { aclChangeRole: instance.$acl.change });
              },
              error => {
                instance.$vs.loading.close();
                instance.$store.dispatch("alert/error", error, { root: true });
              }
            );
        }
      });
    },
    buyCreditsSpei() {
      if (this.isPlanDemo) {
        this.showDemoPlanWarning();
        return;
      }
      this.$store.dispatch("alert/clear", {}, {root: true})
      this.$vs.loading({type: "point"})
      this.$store.dispatch("creditPacks/buySignatures", { amount: this.credits, paymentMethod: "SPEI_METHOD", cardId: '', aclChangeRole: this.$acl.change })
        .then(
          result => {
            this.$vs.loading.close()
            this.downloadBuySheet(result.file);
            this.$store.dispatch("alert/success", "Se ha descargado la ficha de pago", {root: true});
          },
          error => {
            this.$vs.loading.close()
            let errorMessage = error;
            if (this.isPlanDemo || (error && typeof error === 'string' && (error.includes('403') || error.includes('privilegios')))) {
              errorMessage = "Para comprar firmas adicionales debes activar el Plan Flexible.";
            }
            this.$store.dispatch("alert/error", errorMessage, {root: true});
          }
        )
    },
    downloadBuySheet(file) {
      var a = document.createElement("a"); //Create <a>
      a.href = "data:application/pdf;base64," + file; //Image Base64 Goes here
      a.download = "Ficha de pago.pdf"; //File name Here
      a.click(); //Downloaded file
    },
    flipCard(status) {
      this.isCardFlipped = status;
    },
    focusInput(e) {
      this.isInputFocused = true;
      let targetRef = e.target.dataset.ref;
      let target = this.$refs[targetRef];
      this.focusElementStyle = {
        width: `${target.offsetWidth}px`,
        height: `${target.offsetHeight}px`,
        transform: `translateX(${target.offsetLeft}px) translateY(${target.offsetTop}px)`
      }
    },
    blurInput() {
      let vm = this;
      setTimeout(() => {
        if (!vm.isInputFocused) {
          vm.focusElementStyle = null;
        }
      }, 300);
      vm.isInputFocused = false;
    },
    submit(cardId = null) {
      if (this.isPlanDemo) {
        this.showDemoPlanWarning();
        return;
      }
      console.log(this.getSelectedCard)
      this.$store.dispatch("alert/clear", {}, {root: true})
      this.$vs.loading({type: "point"})
      this.$store.dispatch("creditPacks/buySignatures", { amount: this.credits, paymentMethod: "CARD_METHOD", cardId: cardId !== null ? cardId : this.getSelectedCard.payment_id, aclChangeRole: this.$acl.change })
        .then(
          () => {
            this.$vs.loading.close()
            this.popupCard = false;
            this.$store.dispatch("alert/success", "Se han comprado los creditos con éxito", {root: true});

            // Variables necesarias
            const email = this.$store.state.account.user.me.email;
            const phone = this.$store.state.account.user.me.phone;
            const value = this.signaturePrice * this.credits;
            const discountRate = this.isPlanProfesional ? this.discountForProUsers / 100 : 0;
            const currency = 'MXN';
            const idTransaccion = Math.floor(1000000 + Math.random() * 9000000);

            // Calcular precio total con descuento si aplica
            const finalValue = discountRate > 0 ? value * (1 - discountRate) : value;
            const itemId = discountRate > 0 ? 'firmas_profesionales_adicionales' : 'firmas_flexibles_adicionales';

            // Formato del valor final con dos decimales
            const formattedFinalValue = Math.round(finalValue * 100) / 100;

            // Envío de los datos de conversión a Google Ads
            window.gtag('set', 'user_data', {
              "email": email,
              "phone_number": `+${phone}`
            });

            window.gtag('event', 'conversion', {
              'send_to': 'AW-462309740/aoMCCIjw1twZEOySudwB',
              'value': formattedFinalValue,
              'currency': currency,
              'transaction_id': idTransaccion,
              'user_id': email,
              'phone_number': `+${phone}`,
              'items': [
                {
                  'item_id': itemId,
                  'item_name': this.isPlanProfesional ? 'Firmas Profesionales Adicionales' : 'Firmas Flexibles Adicionales',
                  'price': this.signaturePrice, // Precio unitario original
                  "units": "percentage",
                  'discount': discountRate > 0 ? `${discountRate * 100}` : '0',
                  'quantity': this.credits
                }
              ]
            });

            // Evento de compra para Google Analytics 4
            window.gtag('event', 'purchase', {
              'transaction_id': idTransaccion,
              'affiliation': 'Website',
              'value': formattedFinalValue,
              'currency': currency,
              'items': [
                {
                  'item_id': itemId,
                  'item_name': this.isPlanProfesional ? 'Firmas Profesionales Adicionales' : 'Firmas Flexibles Adicionales',
                  "units": "percentage",
                  'discount': discountRate > 0 ? `${discountRate * 100}` : '0',
                  'currency': currency,
                  'price': this.signaturePrice, // Precio unitario original
                  'quantity': this.credits
                }
              ],
              'user_id': email,
              'phone_number': `+${phone}`
            });
            window.fbq('track', 'Purchase', {
              value: formattedFinalValue,
              currency: currency,
              contents: [{
                id: itemId,
                name: this.isPlanProfesional ? 'Firmas Profesionales Adicionales' : 'Firmas Flexibles Adicionales',
                price: this.signaturePrice,
                quantity: this.credits
              }],
              content_type: 'product',
              num_items: this.credits,
              transaction_id: idTransaccion
            });


            setTimeout(() => {
              router.push("/");
            }, 200)
          },
          error => {
            this.$vs.loading.close()
            this.$store.dispatch("alert/error", error, {root: true});
          }
        )
    }
  },
}
</script>

<style lang="scss">

.wrapper {
  min-height: 100vh;
  display: flex;

}

@media screen and (max-width: 700px), (max-height: 500px) {
  .wrapper {
    flex-wrap: wrap;
    flex-direction: column;
  }
}

.card-form2 {
  width: 100%;
}

@media screen and (max-width: 576px) {
  .card-form {
    margin: 0 auto;
  }
}

.card-form__inner {
  background: #fff;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  padding: 35px;
  padding-top: 35px;
}

@media screen and (max-width: 480px) {
  .card-form__inner {
    padding: 25px;
    padding-top: 165px;
  }
}

@media screen and (max-width: 360px) {
  .card-form__inner {
    padding: 15px;
    padding-top: 165px;
  }
}

.card-form__row {
  display: flex;
  align-items: flex-start;
}

@media screen and (max-width: 480px) {
  .card-form__row {
    flex-wrap: wrap;
  }
}

.card-form__col {
  flex: auto;
  margin-right: 35px;
}

.card-form__col:last-child {
  margin-right: 0;
}

@media screen and (max-width: 480px) {
  .card-form__col {
    margin-right: 0;
    flex: unset;
    width: 100%;
    margin-bottom: 20px;
  }
  .card-form__col:last-child {
    margin-bottom: 0;
  }
}

.card-form__col.-cvv {
  max-width: 150px;
}

@media screen and (max-width: 480px) {
  .card-form__col.-cvv {
    max-width: initial;
  }
}

.card-form__group {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.card-form__group .card-input__input {
  flex: 1;
  margin-right: 15px;
}

.card-form__group .card-input__input:last-child {
  margin-right: 0;
}

.card-form__button {
  width: 100%;
  height: 55px;
  background: #4514c7;
  border: none;
  border-radius: 5px;
  font-size: 22px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  box-shadow: 3px 10px 20px 0px rgba(0, 0, 0, 0.3);
  color: #fff;
  margin-top: 20px;
  cursor: pointer;
}

@media screen and (max-width: 480px) {
  .card-form__button {
    margin-top: 10px;
  }
}

.card-item {
  max-width: 430px;
  height: 270px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 2;
  width: 100%;
}

@media screen and (max-width: 480px) {
  .card-item {
    max-width: 310px;
    height: 220px;
    width: 90%;
  }
}

@media screen and (max-width: 360px) {
  .card-item {
    height: 180px;
  }
}

.card-item.-active .card-item__side.-front {
  transform: perspective(1000px) rotateY(180deg) rotateX(0deg) rotateZ(0deg);
}

.card-item.-active .card-item__side.-back {
  transform: perspective(1000px) rotateY(0) rotateX(0deg) rotateZ(0deg);
}

.card-item__focus {
  position: absolute;
  z-index: 3;
  border-radius: 5px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: all 0.35s cubic-bezier(0.71, 0.03, 0.56, 0.85);
  opacity: 0;
  pointer-events: none;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.65);
}

.card-item__focus:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: #08142f;
  height: 100%;
  border-radius: 5px;
  filter: blur(25px);
  opacity: 0.5;
}

.card-item__focus.-active {
  opacity: 1;
}

.card-item__side {
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 20px 60px 0 rgba(0, 0, 0, 0.25);
  transform: perspective(2000px) rotateY(0deg) rotateX(0deg) rotate(0deg);
  transform-style: preserve-3d;
  transition: all 0.8s cubic-bezier(0.71, 0.03, 0.56, 0.85);
  backface-visibility: hidden;
  height: 100%;
}

.card-item__side.-back {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  transform: perspective(2000px) rotateY(-180deg) rotateX(0deg) rotate(0deg);
  z-index: 2;
  padding: 0;
  height: 100%;
}

.card-item__side.-back .card-item__cover {
  transform: rotateY(-180deg);
}

.card-item__bg {
  max-width: 100%;
  display: block;
  max-height: 100%;
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.card-item__cover {
  height: 100%;
  background-color: #1c1d27;
  position: absolute;
  height: 100%;
  background-color: #1c1d27;
  left: 0;
  top: 0;
  width: 100%;
  border-radius: 15px;
  overflow: hidden;
}

.card-item__cover:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(6, 2, 29, 0.45);
}

.card-item__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 40px;
  padding: 0 10px;
}

@media screen and (max-width: 480px) {
  .card-item__top {
    margin-bottom: 25px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__top {
    margin-bottom: 15px;
  }
}

.card-item__chip {
  width: 60px;
}

@media screen and (max-width: 480px) {
  .card-item__chip {
    width: 50px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__chip {
    width: 40px;
  }
}

.card-item__type {
  height: 45px;
  position: relative;
  display: flex;
  justify-content: flex-end;
  max-width: 100px;
  margin-left: auto;
  width: 100%;
}

@media screen and (max-width: 480px) {
  .card-item__type {
    height: 40px;
    max-width: 90px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__type {
    height: 30px;
  }
}

.card-item__typeImg {
  max-width: 100%;
  object-fit: contain;
  max-height: 100%;
  object-position: top right;
}

.card-item__info {
  color: #fff;
  width: 100%;
  max-width: calc(100% - 85px);
  padding: 10px 15px;
  font-weight: 500;
  display: block;
  cursor: pointer;
}

@media screen and (max-width: 480px) {
  .card-item__info {
    padding: 10px;
  }
}

.card-item__holder {
  opacity: 0.7;
  font-size: 13px;
  margin-bottom: 6px;
}

@media screen and (max-width: 480px) {
  .card-item__holder {
    font-size: 12px;
    margin-bottom: 5px;
  }
}

.card-item__wrapper {
  font-family: "Source Code Pro", monospace;
  padding: 25px 15px;
  position: relative;
  z-index: 4;
  height: 100%;

  text-shadow: 7px 6px 10px rgba(0, 0, 0, 0.8);
  user-select: none;
}

@media screen and (max-width: 480px) {
  .card-item__wrapper {
    padding: 20px 10px;
  }
}

.card-item__name {
  font-size: 18px;
  line-height: 1;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
}

@media screen and (max-width: 480px) {
  .card-item__name {
    font-size: 16px;
  }
}

.card-item__nameItem {
  display: inline-block;
  min-width: 8px;
  position: relative;
}

.card-item__number {
  font-weight: 500;
  line-height: 1;
  color: #fff;
  font-size: 27px;
  margin-bottom: 35px;
  display: inline-block;
  padding: 10px 15px;
  cursor: pointer;
}

@media screen and (max-width: 480px) {
  .card-item__number {
    font-size: 21px;
    margin-bottom: 15px;
    padding: 10px 10px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__number {
    font-size: 19px;
    margin-bottom: 10px;
    padding: 10px 10px;
  }
}

.card-item__numberItem {
  width: 16px;
  display: inline-block;
}

.card-item__numberItem.-active {
  width: 30px;
}

@media screen and (max-width: 480px) {
  .card-item__numberItem {
    width: 13px;
  }
  .card-item__numberItem.-active {
    width: 16px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__numberItem {
    width: 12px;
  }
  .card-item__numberItem.-active {
    width: 8px;
  }
}

.card-item__content {
  color: #fff;
  display: flex;
  align-items: flex-start;
}

.card-item__date {
  flex-wrap: wrap;
  font-size: 18px;
  margin-left: auto;
  padding: 10px;
  display: inline-flex;
  width: 80px;
  white-space: nowrap;
  flex-shrink: 0;
  cursor: pointer;
}

@media screen and (max-width: 480px) {
  .card-item__date {
    font-size: 16px;
  }
}

.card-item__dateItem {
  position: relative;
}

.card-item__dateItem span {
  width: 22px;
  display: inline-block;
}

.card-item__dateTitle {
  opacity: 0.7;
  font-size: 13px;
  padding-bottom: 6px;
  width: 100%;
}

@media screen and (max-width: 480px) {
  .card-item__dateTitle {
    font-size: 12px;
    padding-bottom: 5px;
  }
}

.card-item__band {
  background: rgba(0, 0, 19, 0.8);
  width: 100%;
  height: 50px;
  margin-top: 30px;
  position: relative;
  z-index: 2;
}

@media screen and (max-width: 480px) {
  .card-item__band {
    margin-top: 20px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__band {
    height: 40px;
    margin-top: 10px;
  }
}

.card-item__cvv {
  text-align: right;
  position: relative;
  z-index: 2;
  padding: 15px;
}

.card-item__cvv .card-item__type {
  opacity: 0.7;
}

@media screen and (max-width: 360px) {
  .card-item__cvv {
    padding: 10px 15px;
  }
}

.card-item__cvvTitle {
  padding-right: 10px;
  font-size: 15px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 5px;
}

.card-item__cvvBand {
  height: 45px;
  background: #fff;
  margin-bottom: 30px;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
  color: #1a3b5d;
  font-size: 18px;
  border-radius: 4px;
  box-shadow: 0px 10px 20px -7px rgba(0, 0, 0, 0.35);
}

@media screen and (max-width: 480px) {
  .card-item__cvvBand {
    height: 40px;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__cvvBand {
    margin-bottom: 15px;
  }
}

.card-list {
  margin-bottom: -130px;
}

@media screen and (max-width: 480px) {
  .card-list {
    margin-bottom: -120px;
  }
}

.card-input {
  margin-bottom: 20px;
}

.card-input__label {
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: 500;
  color: #1a3b5d;
  width: 100%;
  display: block;
  user-select: none;
}

.card-input__input {
  width: 100%;
  height: 50px;
  border-radius: 5px;
  box-shadow: none;
  border: 1px solid #ced6e0;
  transition: all 0.3s ease-in-out;
  font-size: 18px;
  padding: 5px 15px;
  background: none;
  color: #1a3b5d;
  font-family: "Source Sans Pro", sans-serif;
}

.card-input__input:hover, .card-input__input:focus {
  border-color: #4514c7;
}

.card-input__input:focus {
  box-shadow: 0px 10px 20px -13px rgba(0, 0, 0, 0.35);
}

.card-input__input.-select {
  -webkit-appearance: none;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAeCAYAAABuUU38AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUxJREFUeNrM1sEJwkAQBdCsngXPHsQO9O5FS7AAMVYgdqAd2IGCDWgFnryLFQiCZ8EGnJUNimiyM/tnk4HNEAg/8y6ZmMRVqz9eUJvRaSbvutCZ347bXVJy/ZnvTmdJ862Me+hAbZCTs6GHpyUi1tTSvPnqTpoWZPUa7W7ncT3vK4h4zVejy8QzM3WhVUO8ykI6jOxoGA4ig3BLHcNFSCGqGAkig2yqgpEiMsjSfY9LxYQg7L6r0X6wS29YJiYQYecemY+wHrXD1+bklGhpAhBDeu/JfIVGxaAQ9sb8CI+CQSJ+QmJg0Ii/EE2MBiIXooHRQhRCkBhNhBcEhLkwf05ZCG8ICCOpk0MULmvDSY2M8UawIRExLIQIEgHDRoghihgRIgiigBEjgiFATBACAgFgghEwSAAGgoBCBBgYAg5hYKAIFYgHBo6w9RRgAFfy160QuV8NAAAAAElFTkSuQmCC");
  background-size: 12px;
  background-position: 90% center;
  background-repeat: no-repeat;
  padding-right: 30px;
}

.slide-fade-up-enter-active {
  transition: all 0.25s ease-in-out;
  transition-delay: 0.1s;
  position: relative;
}

.slide-fade-up-leave-active {
  transition: all 0.25s ease-in-out;
  position: absolute;
}

.slide-fade-up-enter {
  opacity: 0;
  transform: translateY(15px);
  pointer-events: none;
}

.slide-fade-up-leave-to {
  opacity: 0;
  transform: translateY(-15px);
  pointer-events: none;
}

.slide-fade-right-enter-active {
  transition: all 0.25s ease-in-out;
  transition-delay: 0.1s;
  position: relative;
}

.slide-fade-right-leave-active {
  transition: all 0.25s ease-in-out;
  position: absolute;
}

.slide-fade-right-enter {
  opacity: 0;
  transform: translateX(10px) rotate(45deg);
  pointer-events: none;
}

.slide-fade-right-leave-to {
  opacity: 0;
  transform: translateX(-10px) rotate(45deg);
  pointer-events: none;
}

.github-btn {
  position: absolute;
  right: 40px;
  bottom: 50px;
  text-decoration: none;
  padding: 15px 25px;
  border-radius: 4px;
  box-shadow: 0px 4px 30px -6px rgba(0, 0, 0, 0.65);
  background: #24292e;
  color: #fff;
  font-weight: bold;
  letter-spacing: 1px;
  font-size: 16px;
  text-align: center;
  transition: all .3s ease-in-out;
}

@media screen and (min-width: 500px) {
  .github-btn:hover {
    transform: scale(1.1);
    box-shadow: 0px 17px 20px -6px rgba(0, 0, 0, 0.36);
  }
}

@media screen and (max-width: 700px) {
  .github-btn {
    position: relative;
    bottom: auto;
    right: auto;
    margin-top: 20px;
  }
  .github-btn:active {
    transform: scale(1.1);
    box-shadow: 0px 17px 20px -6px rgba(0, 0, 0, 0.36);
  }
}


.bg-text-grey {
  background: #f2f2f2 !important;
}

.greet-user {
  position: relative;

  .decore-left {
    position: absolute;
    left: 0;
    top: 0;
  }

  .decore-right {
    position: absolute;
    right: 0;
    top: 0;
  }
}

@media screen and (max-width: 1350px) {
  .w-1400-100 {
    width: 100% !important;
  }
}

ol {
  list-style: none;
  counter-reset: my-awesome-counter;
}

ol li {
  counter-increment: my-awesome-counter;
}

ol li::before {
  content: counter(my-awesome-counter) ". ";
  color: #4514c7;

}
.p-btn-sg{
  padding: .679rem .679rem!important;
}
.d-contens{
  display: contents!important;
}
.card-sig{
  .vx-card__collapsible-content{
    .vx-card__body{
      padding: 1.9rem!important;
    }
  }
}

.card-form__inner_2{
  border-radius: 10px;
  padding: 35px;
}
.card-list-select{
  .vs-divider{
    margin: 0;
  }
}
.card-select{
  padding-bottom: 15px;
  padding-top: 15px;
  padding-left: 20px;
  cursor: pointer;
  -webkit-transition: all .3s ease 0s;
  transition: all .3s ease 0s;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  &:last-child {
    border-bottom: none;
  }
  .vs-radio--label{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &:hover{
    background: #f5f5f5;
  }
}


</style>

